var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var SearchIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 57,
    glyphHeight: 57,
    glyphOffsetY: 4.5,
    glyphOffsetX: 2.5
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3696 50.5271L44.3106 38.4681C47.0438 34.5575 48.6417 29.806 48.6417 24.6761C48.6417 11.3466 37.8351 0.540039 24.5056 0.540039C11.1762 0.540039 0.369629 11.3466 0.369629 24.6761C0.369629 38.0055 11.1762 48.8121 24.5056 48.8121C29.5095 48.8121 34.1769 47.2563 38.0454 44.6492L50.1193 56.7232C52.4175 54.887 54.5138 52.8088 56.3696 50.5271ZM9.19988 24.7181C9.19988 33.1699 16.0959 40.0659 24.5477 40.0659C32.9995 40.0659 39.8955 33.1699 39.8955 24.7181C39.8955 16.2663 32.9995 9.37029 24.5477 9.37029C16.0959 9.37029 9.19988 16.2663 9.19988 24.7181Z"
  }));
};
export var SearchIconGlyph = function (props) {
  return React.createElement(SearchIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};